// extracted by mini-css-extract-plugin
export default {"date":"Date_date__OH9Ua","date__bottom":"Date_date__bottom__nFVyT","date__bottom_dot":"Date_date__bottom_dot__CjnuU","date__bottom_line":"Date_date__bottom_line__AiSgM"};